module.exports = __webpack_public_path__ + "static/media/mail.e93d5761.svg";